import React from 'react'
import { Result as ResultAnt, Spin } from 'antd'
import { ResultProps } from 'antd/lib/result'

import { useT } from 'src/core/hooks/use-translation'

function Result({ icon = <Spin />, subTitle, title, ...props }: ResultProps) {
  const { t } = useT()
  return (
    <ResultAnt {...props} icon={icon} subTitle={t(subTitle)} title={t(title)} />
  )
}

export default Result
